import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { estEnCoursDeChargement } from '../../App_Code/Utils';
import { mapStateToPropsWrapper, verificationProps } from '../CaptureErreurs';
import Chargement from '../Chargement';
import Card, { LigneCard } from '../Card';

const CardBanque = ({ EstMembreCS, Banques, ComptaEnReprise_Visible, EtatGestion }) => {
    if (estEnCoursDeChargement(Banques)) return <Chargement titreCard="Compte bancaire" />;
    if (Banques.length === 0) return null;
    const Banque = Banques.find(banque => banque.Compte && banque.Compte.Code === 'BNQ');
    const pasDeCompte = !Banque || !Banque.Compte || !Banque.Rib;

    /* S'il n'y a pas de compte principal et que le propriétaire n'est pas membre du CS, il n'est pas nécessaire d'afficher la Card */
    if (pasDeCompte && !EstMembreCS) return null;

    return (
        <Card Titre={CardBanque.titleName}>
        { ((ComptaEnReprise_Visible==0 && EtatGestion==1) || (ComptaEnReprise_Visible==2 && EtatGestion==1 && !EstMembreCS )) ?
            <React.Fragment>
                <div className="card-text mb-3">
                        <p style={{fontSize:"14px",fontWeight:"bold",padding:"20px 0 20px 20px"}}>Reprise comptable en cours.
                        <br/>L'accès aux informations est momentanément suspendu.</p>
                </div>
            </React.Fragment>
            :
            <React.Fragment>
                <div className="card-text mb-3">
                    {pasDeCompte ? (
                        <i>Il n&apos;y a pas de compte principal pour cette copropriété.</i>
                    ) : (
                        <React.Fragment>
                            <LigneCard titre="Intitulé" valeur={Banque.Compte.Nom} />
                            <LigneCard titre="IBAN" valeur={Banque.Rib.Iban} classeValeur="font-weight-bold" />
                            <LigneCard titre="BIC" valeur={Banque.Rib.Bic} derniereLigne />
                            <LigneCard titre="Titulaire" valeur={Banque.Rib.NomSurRIB} />
                        </React.Fragment>
                    )}
                </div>
                {EstMembreCS && (
                    <Link to="/MaCopropriete/Banques" className="btn btn-outline-primary">
                        <span className="badge badge-pill badge-cs mr-1" title="Vous avez accès à cette section car vous êtes membre du conseil syndical">
                            CS 
                        </span>
                        Voir les comptes bancaires
                    </Link>
                )}
            </React.Fragment> 
        }
        </Card>
    );
};
CardBanque.displayName = 'CardBanque';
CardBanque.titleName = 'Compte bancaire';
CardBanque.requiredProps = [
    'Banques', // Liste des banques
];

function mapStateToProps({ 
    AdhStore: { EstMembreCS }, 
    CopStore: { 
        Cop: { EtatGestion },
        Banques, 
    },
    SynStore: {
        Syn : { 
            ComptaEnReprise_Visible,
         },
    }
 }) {
    return { EstMembreCS, Banques, EtatGestion, ComptaEnReprise_Visible };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardBanque));



// WEBPACK FOOTER //
// ./src/components/MaCopro/CardBanque.js